import { Loading } from 'element-ui'
import css from './index.module.scss'

let loadingIns = { current: null }

const defaultOptions = {
    type: 'loading' /** loading | success | fail */,
    timeout: 2000,
}

export function Toast(text, propType = 'loading', options = defaultOptions) {
    const spinner = (() => {
        const type = (options.type = propType)
        if (type === 'success') return 'el-icon-check'
        else if (type === 'fail') return 'el-icon-warning-outline'

        return 'el-icon-loading'
    })()

    if (loadingIns.current) loadingIns.current.close()
    loadingIns.current = Loading.service({
        text,
        fullscreen: true,
        background: 'transparent',
        target: document.body,
        spinner,
        customClass: css['loading'],
    })

    if (options.timeout && options.type !== 'loading') {
        setTimeout(() => loadingIns.current.close(), options.timeout)
    }

    return loadingIns.current
}

Toast.close = () => loadingIns.current && loadingIns.current.close()
